import { MARQUEE } from "@/data/site";

const Row = ({ hidden }) => (
  <ul className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
    {MARQUEE.map((m) => (
      <li key={m} className="flex items-center whitespace-nowrap font-display text-[clamp(2rem,5vw,4.5rem)] font-medium tracking-[-0.04em]">
        <span className="px-6 lg:px-10">{m}</span>
        <span className="text-ash" aria-hidden="true">/</span>
      </li>
    ))}
  </ul>
);

export const Marquee = () => (
  <section aria-label="Disciplines" data-testid="editorial-marquee" className="overflow-hidden border-y border-ink/15 py-6 lg:py-8">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
